import { put, call , all} from "redux-saga/effects";
import {
  getLifestyleChartsSuccessAction,
  getLifestyleChartsFailureAction,
  getRecommendedDietPlanSuccessAction,
  getRecommendedDietPlanFailureAction,
  getRecommendedLifestyleSuccessAction,
  getRecommendedLifestyleFailureAction,
  getPatientDetailsSuccessAction,
  getPatientDetailsFailureAction,
  getPatientVitalsSuccessAction,
  getPatientVitalsFailureAction,
  getPatientConsultationDetailsSuccessAction,
  getPatientConsultationDetailsFailureAction,
  getPatientVitalsRangeSuccessAction,
  getPatientVitalsRangeFailureAction,
  getPatientLeapScoreSuccessAction,
  getPatientLeapScoreFailureAction,
  getPatientHistoryDataSuccessAction,
  getPatientHistoryDataFailureAction,
  createPatientHistoryDataSuccessAction,
  createPatientHistoryDataFailureAction,
  updatePatientHistoryDataSuccessAction,
  updatePatientHistoryDataFailureAction,
  createVitalsSuccessAction,
  createVitalsFailureAction,
  getPatientTestsSuccessAction,
  getPatientTestsFailureAction,
  submitPatientTestsSuccessAction,
  submitPatientTestsFailureAction,
  getEmotionChartsSuccessAction,
  getEmotionChartsFailureAction,
  getPhysicalFitnessSuccessAction,
  getPhysicalFitnessFailureAction,
  createOrUpdateRecommendedLifestyleSuccessAction,
  createOrUpdateRecommendedLifestyleFailureAction,
  getWeightGainChartSuccessAction,
  getWeightGainChartFailureAction,
  getVisitsChartsSuccessAction,
  getVisitsChartsFailureAction,
  getPatientComplaintsSuccessAction,
  getPatientComplaintsFailureAction,
  getPatientRisksSuccessAction,
  getPatientRisksFailureAction,
  createComplaintSuccessAction,
  createComplaintFailureAction,
  createRiskSuccessAction,
  createRiskFailureAction,
  updateComplaintSuccessAction,
  updateComplaintFailureAction,
  updateRiskSuccessAction,
  updateRiskFailureAction,
  getPatientVitalsRequestAction,
  getPatientComplaintsRequestAction,
  getPatientRisksRequestAction,
  updatePatientDetailsSuccessAction,
  updatePatientDetailsFailureAction,
  getPatientEndedComplaintsRequestAction,
  getPatientEndedRisksRequestAction,
  addWeightGainChartDataSuccessAction,
  addWeightGainChartDataFailureAction,
  getWeightGainChartRequestAction,
  getPatientDetailsRequestAction,
  getPrescriptionChartSuccessAction,
  getPrescriptionChartFailureAction,
  getDFMRChartSuccessAction,
  getDFMRChartFailureAction,
  getEmotionDataSuccessAction,
  getEmotionDataFailureAction,
  createConditionSuccessAction,
  getConditionSuccessAction,
  getConditionFailureAction,
  getConditionTimelineSuccessAction,
  getConditionTimelineFailureAction,
} from "../actions/patientActions";
import { END_POINTS } from "../../api/endpoints";
import { API } from "../../api/api";
import { getComplaintsSuccessAction } from "../actions/hospitalActions";

// ------ get patient details ------

export function* getPatientDetails(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientDetailsResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.patient(action.payload.patientId)}`
    );

    if (!patientDetailsResponse.success) {
      throw new Error(patientDetailsResponse.message);
    }
    yield put(getPatientDetailsSuccessAction(patientDetailsResponse.data));
  } catch (error) {
    yield put(getPatientDetailsFailureAction(error.message));
  }
}

export function* getPatientVitals(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientVitalsResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.vitals(action.payload.patientId)}`
    );

    if (!patientVitalsResponse.success) {
      throw new Error(patientVitalsResponse.message);
    }
    yield put(getPatientVitalsSuccessAction(patientVitalsResponse.data));
  } catch (error) {
    yield put(getPatientVitalsFailureAction(error.message));
  }
}

export function* getPatientConsultations(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const consultationResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.consultation(action.payload.consultationId)}`
    );

    if (!consultationResponse.success) {
      throw new Error(consultationResponse.message);
    }
    yield put(
      getPatientConsultationDetailsSuccessAction(consultationResponse.data)
    );
  } catch (error) {
    yield put(getPatientConsultationDetailsFailureAction(error.message));
  }
}

export function* getPatientVitalsRange(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientVitalsRangeResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.vitalsRange(action.payload.patientId)}`
    );

    if (!patientVitalsRangeResponse.success) {
      throw new Error(patientVitalsRangeResponse.message);
    }
    yield put(
      getPatientVitalsRangeSuccessAction(patientVitalsRangeResponse.data)
    );
  } catch (error) {
    yield put(getPatientVitalsRangeFailureAction(error.message));
  }
}

export function* getPatientLeapScore(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientLeapResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.patientLeapScore(action.payload.patientId)}`
    );

    if (!patientLeapResponse.success) {
      throw new Error(patientLeapResponse.message);
    }
    yield put(getPatientLeapScoreSuccessAction(patientLeapResponse.data));
  } catch (error) {
    yield put(getPatientLeapScoreFailureAction(error.message));
  }
}

export function* getPatientHistoryDetails(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientHistoryResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.patientHistory(action.payload.patientId)}`
    );

    if (!patientHistoryResponse.success) {
      throw new Error(patientHistoryResponse.message);
    }
    yield put(getPatientHistoryDataSuccessAction(patientHistoryResponse.data));
  } catch (error) {
    yield put(getPatientHistoryDataFailureAction(error.message));
  }
}

export function* createPatientHistoryDetails(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientHistoryResponse = yield call(
      API.post,
      `${baseUrl}${END_POINTS.patientHistory(action.payload.patientId)}`,
      {
        // patientId: action.payload.patientId,
        ...action.payload.body,
      }
    );

    if (!patientHistoryResponse.success) {
      throw new Error(patientHistoryResponse.message);
    }
    yield put(
      createPatientHistoryDataSuccessAction(patientHistoryResponse.data)
    );
    // yield put(getPatientDetailsRequestAction(action.payload.patientId))
  } catch (error) {
    yield put(createPatientHistoryDataFailureAction(error.message));
  }
}

export function* updatePatientHistoryDetails(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientHistoryResponse = yield call(
      API.put,
      `${baseUrl}${END_POINTS.patientHistory(action.payload.patientId)}`,
      {
        // patientId: action.payload.patientId,
        ...action.payload.body,
      }
    );
    if (!patientHistoryResponse.success) {
      throw new Error(patientHistoryResponse.message);
    }
    yield put(
      updatePatientHistoryDataSuccessAction(patientHistoryResponse.data)
    );
    // yield put(getPatientDetailsRequestAction(action.payload.patientId))
  } catch (error) {
    yield put(updatePatientHistoryDataFailureAction(error.message));
  }
}

export function* createVitals(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const vitalsResponse = yield call(
      API.post,
      `${baseUrl}${END_POINTS.vitalUpdate(action.payload.consultationId)}`,
      {
        ...action.payload.body,
      }
    );

    if (!vitalsResponse.success) {
      throw new Error(vitalsResponse.message);
    }
    yield put(createVitalsSuccessAction(vitalsResponse.data));
    yield put(getPatientVitalsRequestAction(vitalsResponse.data.patientId))
  } catch (error) {
    yield put(createVitalsFailureAction(error.message));
  }
}

export function* getPatientTests(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const testsResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.testList(action.payload.patientId)}`
    );

    if (!testsResponse.success) {
      throw new Error(testsResponse.message);
    }
    yield put(getPatientTestsSuccessAction(testsResponse.data));
  } catch (error) {
    yield put(getPatientTestsFailureAction(error.message));
  }
}

export function* submitPatientTestsResponse(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const testResponse = yield call(
      API.patch,
      `${baseUrl}${END_POINTS.submitTestResponse(action.payload.testId)}`,
      {
        ...action.payload.body,
      }
    );
    if (!testResponse.success) {
      throw new Error(testResponse.message);
    }
    yield put(submitPatientTestsSuccessAction(testResponse.data));
    // if (!testResponse.id) {
    //     throw new Error("Bad Request")
    // }
    // yield put(submitPatientTestsSuccessAction(testResponse));
  } catch (error) {
    yield put(submitPatientTestsFailureAction(error.message));
  }
}

export function* getLifestyleCharts(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const lifestyleChartResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.lifestyleCharts(action.payload.patientId)}`
    );

    if (!lifestyleChartResponse.success) {
      throw new Error(lifestyleChartResponse.message);
    }
    yield put(getLifestyleChartsSuccessAction(lifestyleChartResponse.data));
  } catch (error) {
    yield put(getLifestyleChartsFailureAction(error.message));
  }
}

export function* getRecommendedDietPlan(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const recommendationdietPlanResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.recommendedDietPlan(
        action.payload.consultationId
      )}`
    );

    if (!recommendationdietPlanResponse.success) {
      throw new Error(recommendationdietPlanResponse.message);
    }
    yield put(
      getRecommendedDietPlanSuccessAction(recommendationdietPlanResponse.data)
    );
  } catch (error) {
    yield put(getRecommendedDietPlanFailureAction(error.message));
  }
}

export function* getRecommendedLifestyle(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const recommendedLifestyleResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.recommendedLifestyle(
        action.payload.consultationId
      )}`
    );

    if (!recommendedLifestyleResponse.success) {
      throw new Error(recommendedLifestyleResponse.message);
    }
    yield put(
      getRecommendedLifestyleSuccessAction(recommendedLifestyleResponse.data)
    );
  } catch (error) {
    yield put(getRecommendedLifestyleFailureAction(error.message));
  }
}

export function* createOrUpdateRecommendedLifestyle(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;

    const endpoint = `${baseUrl}/v1/consultations/${action.payload.consultationId}/recommended-lifestyle/create-or-update`;

    const response = yield call(API.put, endpoint, action.payload.body);

    if (!response.success) {
      throw new Error(response.message);
    }

    yield put(createOrUpdateRecommendedLifestyleSuccessAction(response.data));
  } catch (error) {
    yield put(createOrUpdateRecommendedLifestyleFailureAction(error.message));
  }
}

export function* getEmotionCharts(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const emotionChartsResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.emotionCharts(action.payload.patientId)}`
    );

    if (!emotionChartsResponse.success) {
      throw new Error(emotionChartsResponse.message);
    }
    yield put(getEmotionChartsSuccessAction(emotionChartsResponse.data));
  } catch (error) {
    yield put(getEmotionChartsFailureAction(error.message));
  }
}

export function* getPhysicalFitness(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const physicalFitnessResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.physicalFitness(action.payload.patientId)}`
    );

    if (!physicalFitnessResponse.success) {
      throw new Error(physicalFitnessResponse.message);
    }
    yield put(getPhysicalFitnessSuccessAction(physicalFitnessResponse.data));
  } catch (error) {
    yield put(getPhysicalFitnessFailureAction(error.message));
  }
}

export function* getWeightGainCharts(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const weightGainChartResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.weightGainChart(action.payload.patientId)}`
    );

    if (!weightGainChartResponse.success) {
      throw new Error(weightGainChartResponse.message);
    }
    yield put(getWeightGainChartSuccessAction(weightGainChartResponse.data));
  } catch (error) {
    yield put(getWeightGainChartFailureAction(error.message));
  }
}

export function* getVisitsCharts(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const visitsChartsResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.visitsCharts(action.payload.patientId)}`
    );

    if (!visitsChartsResponse.success) {
      throw new Error(visitsChartsResponse.message);
    }
    yield put(getVisitsChartsSuccessAction(visitsChartsResponse.data));
  } catch (error) {
    yield put(getVisitsChartsFailureAction(error.message));
  }
}


export function* getPatientComplaints(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientComplaintsResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.patientComplaints(action.payload.patientId, action.payload.status)}`
    );

    if (!patientComplaintsResponse.success) {
      throw new Error(patientComplaintsResponse.message);
    }
    yield put(getPatientComplaintsSuccessAction(patientComplaintsResponse.data, action.payload.status));
 
  } catch (error) {
    yield put(getPatientComplaintsFailureAction(error.message));
  }
}

export function* getPatientRisks(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientRisksResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.patientRisks(action.payload.patientId, action.payload.status)}`
    );

    if (!patientRisksResponse.success) {
      throw new Error(patientRisksResponse.message);
    }
    yield put(getPatientRisksSuccessAction(patientRisksResponse.data, action.payload.status));
  } catch (error) {
    yield put(getPatientRisksFailureAction(error.message));
  }
}

export function* getPatientRiskAsses(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientRisksResponse = yield call(
      API.post,
      `${baseUrl}${END_POINTS.patientRiskAssess(action.payload.patientId,)}`
    );

    if (!patientRisksResponse.success) {
      throw new Error(patientRisksResponse.message);
    }
    yield put(getPatientRisksSuccessAction(patientRisksResponse.data,"ONGOING"));
  } catch (error) {
    yield put(getPatientRisksFailureAction(error.message));
  }
}

export function* createPatientComplaint(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const complaintResponse = yield call(
      API.post,
      `${baseUrl}${END_POINTS.createComplaint(action.payload.patientId)}`,
      {
        patientId: action.payload.patientId,
        ...action.payload.body,
      }
    );

    if (!complaintResponse.success) {
      throw new Error(complaintResponse.message);
    }
    yield put(
      createComplaintSuccessAction(complaintResponse.data)
    );
    if (action.payload.body.status == 'ONGOING') {
      yield put(
        getPatientComplaintsRequestAction(action.payload.patientId, 'ONGOING')
      );
    }
    else {
      yield put(
        getPatientEndedComplaintsRequestAction(action.payload.patientId, 'ENDED')
      );
    }
  } catch (error) {
    yield put(createComplaintFailureAction(error.message));
  }
}

export function* createPatientRisk(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const riskResponse = yield call(
      API.post,
      `${baseUrl}${END_POINTS.createRisk(action.payload.patientId)}`,
      {
        patientId: action.payload.patientId,
        ...action.payload.body,
      }
    );

    if (!riskResponse.success) {
      throw new Error(riskResponse.message);
    }
    yield put(
      createRiskSuccessAction(riskResponse.data)
    );
    if (action.payload.body.status == 'ONGOING') {
      yield put(
        getPatientRisksRequestAction(action.payload.patientId, 'ONGOING')
      );
    }
    else {
      yield put(
        getPatientEndedRisksRequestAction(action.payload.patientId, 'ENDED')
      );
    }
  } catch (error) {
    yield put(createRiskFailureAction(error.message));
  }
}

export function* updatePatientComplaint(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const complaintResponse = yield call(
      API.patch,
      `${baseUrl}${END_POINTS.updateComplaint(action.payload.patientId, action.payload.complaintId)}`,
      {
        ...action.payload.body,
      }
    );

    if (!complaintResponse.success) {
      throw new Error(complaintResponse.message);
    }
    yield put(
      updateComplaintSuccessAction(complaintResponse.data)
    );
    yield all([
      put(getPatientComplaintsRequestAction(action.payload.patientId, 'ONGOING')),
      put( getPatientEndedComplaintsRequestAction(action.payload.patientId, 'ENDED')),
    ]);
  } catch (error) {
    yield put(updateComplaintFailureAction(error.message));
  }
}

export function* updatePatientRisk(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const riskResponse = yield call(
      API.patch,
      `${baseUrl}${END_POINTS.updateRisk(action.payload.patientId, action.payload.riskId)}`,
      {
        ...action.payload.body,
      }
    );

    if (!riskResponse.success) {
      throw new Error(riskResponse.message);
    }
    yield put(
      updateRiskSuccessAction(riskResponse.data)
    );
    yield all([
      put(getPatientRisksRequestAction(action.payload.patientId, 'ONGOING')),
      put( getPatientEndedRisksRequestAction(action.payload.patientId, 'ENDED')),
    ]);

  } catch (error) {
    yield put(updateRiskFailureAction(error.message));
  }
}

export function* updatePatientDetails(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientResponse = yield call(
      API.patch,
      `${baseUrl}${END_POINTS.updatePatientDetails(action.payload.patientId)}`,
      {
        ...action.payload.body,
      }
    );

    if (!patientResponse.success) {
      throw new Error(patientResponse.message);
    }
    yield put(updatePatientDetailsSuccessAction(patientResponse.data));
    yield put(getPatientDetailsRequestAction(action.payload.patientId, true))
  } catch (error) {
    yield put(updatePatientDetailsFailureAction(error.message));
  }
}

export function* addPatientWeightGain(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const patientWeightResponse = yield call(
      API.post,
      `${baseUrl}${END_POINTS.recordPatientWeight(action.payload.consultationId)}`,
      {
       weight:parseInt(action.payload.body),
      }
    );

    if (!patientWeightResponse.success) {
      throw new Error(patientWeightResponse.message);
    }
    yield put(
      addWeightGainChartDataSuccessAction(patientWeightResponse.data)
    );
    yield put(getWeightGainChartRequestAction(action.payload.patientId));
  } catch (error) {
    yield put(addWeightGainChartDataFailureAction(error.message));
  }
}

export function* getPrescriptionChart(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const prescriptionChartResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.getPrescriptionChart(action.payload.patientId)}`
    );

    if (!prescriptionChartResponse.success) {
      throw new Error(prescriptionChartResponse.message);
    }
    yield put(getPrescriptionChartSuccessAction(prescriptionChartResponse.data));
  } catch (error) {
    yield put(getPrescriptionChartFailureAction(error.message));
  }
}

export function* getDFMRChart(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const dfmrChartResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.getDfmrChart(action.payload.patientId)}`
    );
    if (!dfmrChartResponse.data) {
      throw new Error(dfmrChartResponse.message);
    }
    yield put(getDFMRChartSuccessAction(dfmrChartResponse.data));
  } catch (error) {
    yield put(getDFMRChartFailureAction(error.message));
  }
}

export function* getEmotionData(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const emotionResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.getEmotionData(action.payload.patientId)}`
    );
    if (!emotionResponse.success) {
      throw new Error(emotionResponse.message);
    }
    yield put(getEmotionDataSuccessAction(emotionResponse.data));
  } catch (error) {
    yield put(getEmotionDataFailureAction(error.message));
  }
}

export function* postConditionData(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const conditionResponse = yield call(
      API.post,
      `${baseUrl}${END_POINTS.postCondition(action.payload.consultationId)}`,
      {
        ...action.payload.body
      }
    );
    if (!conditionResponse.success) {
      throw new Error(conditionResponse.message);
    }
    yield put(createConditionSuccessAction(conditionResponse.data));
  } catch (error) {
    yield put(createComplaintFailureAction(error.message));
  }
}

export function* getComplaintWithConditionData(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const conditionResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.getComplaintWithCondition()}`,
    );
    if (!conditionResponse.success) {
      throw new Error(conditionResponse.message);
    }
    yield put(getConditionSuccessAction(conditionResponse.data));
  } catch (error) {
    yield put(getConditionFailureAction(error.message));
  }
}

export function* getPatientTimeline(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const conditionResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.conditionTimeline(action.payload.patientId)}`,
    );
    if (!conditionResponse.success) {
      throw new Error(conditionResponse.message);
    }
    yield put(getConditionTimelineSuccessAction(conditionResponse.data));
  } catch (error) {
    yield put(getConditionTimelineFailureAction(error.message));
  }
}